<template>
  <div class="password-field">
    <v-text-field
      v-model="password"
      class="mm-input pb-3"
      color="blue darken-1"
      :placeholder="placeholder"
      hide-details
      loading
      :disabled="disabled"
      :rules="[ValidationRules.requiredString, passStrengthRule]"
      ref="password"
      data-qa="password"
      :type="showPass ? 'text' : 'password'"
      v-on="$listeners"
      v-bind="{ ...$attrs, ...$props }"
    >
      <template #progress>
        <v-progress-linear
          :value="passLength"
          :color="color"
          absolute
          height="3"
        ></v-progress-linear>
      </template>
      <template #append>
        <v-icon @click="showPass = !showPass">{{
          showPass ? 'mdi-eye' : 'mdi-eye-off'
        }}</v-icon>
      </template>
    </v-text-field>
    <ul class="pb-3">
      <li :class="{ isValid: containsEightCharacters }">8 Characters</li>
      <li :class="{ isValid: containsNumberOrSpecialChar }"
        >Contains Number or Special Character</li
      >
      <li :class="{ isValid: containsUppercase }">Contains Uppercase</li>
    </ul>
  </div>
</template>

<script>
import ValidationRules from '@/constants/ValidationRules'
export default {
  name: 'SetPasswordField',
  props: {
    placeholder: {
      type: String,
      default: 'Password',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      password: '',
      showPass: false,
      ValidationRules,
      passStrengthRule: () => {
        return this.isPasswordValid || 'Invalid password'
      },
    }
  },
  computed: {
    passLength() {
      return (this.password.length / 8) * 100
    },
    containsEightCharacters() {
      return this.password.length >= 8
    }, // containsEightCharacters

    containsNumberOrSpecialChar() {
      // https://codepen.io/rauldronca/pen/OwKMGX
      const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/
      return format.test(this.password) || /\d/.test(this.password)
    }, // containsNumber
    containsUppercase() {
      return /[A-Z]/.test(this.password)
    }, // containsUppercase
    isPasswordValid() {
      return (
        this.containsEightCharacters &&
        this.containsNumberOrSpecialChar &&
        this.containsUppercase
      )
    }, // isPasswordValid
    color() {
      let passwordIsValid = this.$refs.password
        ? this.$refs.password.validate()
        : false
      let colorOpts = ['error', 'warning']
      if (passwordIsValid) {
        colorOpts.push('success')
      }
      let index = Math.min(
        colorOpts.length - 1,
        Math.floor(this.passLength / 40)
      )
      return colorOpts[index]
    },
  },
}
</script>

<style lang="scss" scoped>
ul {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
li {
  font-size: 0.8rem;
  margin-bottom: 1px;
  color: #525f7f;
  position: relative;
}

li:before {
  content: '';
  width: 0%;
  height: 2px;
  background: #2ecc71;
  position: absolute;
  left: 0;
  top: 50%;
  display: block;
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.isValid {
  color: rgba(136, 152, 170, 0.8);
}
.isValid:before {
  width: 100%;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
